<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>कूपन   </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='1' >
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/RLUj"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id='2'>

                    <h2 class="mt-2"> कूपन क्या है?  </h2>
                    <label for="">कूपन आम तौर पर एक प्रचार कोड या डिस्काउंट वाउचर को संदर्भित करता है जिसका उपयोग ग्राहक अपनी खरीदारी पर छूट प्राप्त करने के लिए चेकआउट प्रक्रिया के दौरान कर सकते हैं। पे जी अक्सर कूपन कार्यक्षमता को एकीकृत करता है, जिससे व्यापारियों को प्रचार बनाने और प्रबंधित करने की अनुमति मिलती है। </label>
                </div>

                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id='3'>
                    <h2 class="mt-3">यहां बताया गया है कि यह आम तौर पर कैसे काम करता है:  </h2>
                    <label for="" class="mt-3"><b> निर्माण:&nbsp;</b> व्यापारी विशिष्ट छूट मूल्यों, प्रतिशत या अन्य प्रचार प्रस्तावों के साथ कूपन कोड बना सकते हैं।  </label>
                    <label for="" class="mt-3"><b> वितरण: &nbsp;</b>व्यापारी इन कूपन कोड को ईमेल, सोशल मीडिया या विज्ञापनों जैसे विभिन्न चैनलों के माध्यम से ग्राहकों को वितरित कर सकते हैं।  </label>
                    <label for="" class="mt-3"><b>मोचन: &nbsp;</b> ग्राहक चेकआउट के दौरान कूपन कोड दर्ज करते हैं। पे जी कोड को सत्यापित करता है और लेनदेन राशि पर संबंधित छूट लागू करता है।  
                        amount.</label>
                    <label for="" class="mt-3"><b> प्रसंस्करण: &nbsp;</b>पे जी रियायती लेनदेन राशि को संसाधित करता है, और शेष राशि ग्राहक की चुनी हुई भुगतान विधि से ली जाती है। </label>
                    <label for="" class="mt-3">कूपन व्यापारियों के लिए नए ग्राहकों को आकर्षित करने, मौजूदा ग्राहकों को बनाए रखने और बिक्री बढ़ाने के लिए एक प्रभावी उपकरण हो सकता है। पे जी व्यापारियों के लिए ऑनलाइन भुगतान प्रक्रिया में कूपन कार्यक्षमता के निर्बाध एकीकरण की सुविधा प्रदान करने में महत्वपूर्ण भूमिका निभाता है। </label>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id='4'>
                    <h2 class="mt-3">कूपन व्यापारियों की किस प्रकार सहायता करते हैं? </h2>
                    <label for="">ई-कॉमर्स के लगातार विकसित हो रहे परिदृश्य में, प्रतिस्पर्धा से आगे रहना और अपने राजस्व को अधिकतम करना महत्वपूर्ण है। आपके पास एक शक्तिशाली उपकरण कूपन का रणनीतिक उपयोग है। यहां बताया गया है कि आप जैसे व्यापारियों के लिए कूपन क्यों आवश्यक हैं और वे आपके व्यवसाय को कैसे महत्वपूर्ण रूप से प्रभावित कर सकते हैं:  </label>


                    <label for="" class="mt-3"><b>ग्राहक अधिग्रहण:&nbsp;</b>  कूपन नए ग्राहकों के लिए प्रतिस्पर्धियों के मुकाबले आपके उत्पादों या सेवाओं को चुनने के लिए एक आकर्षक प्रोत्साहन है।  </label>
                    <label for="">पहली खरीदारी पर छूट की पेशकश संभावित खरीदारों को प्रारंभिक कदम उठाने और यह अनुभव करने के लिए प्रोत्साहित करती है कि आपका व्यवसाय क्या पेशकश कर रहा है। </label>

                    <label for="" class="mt-3"><b> ग्राहक प्रतिधारण: &nbsp;</b>कूपन केवल नए ग्राहकों को आकर्षित करने के लिए नहीं हैं; वे मौजूदा को बनाए रखने में भी समान रूप से प्रभावी हैं। </label>
                    <label for="">बार-बार आने वाले ग्राहकों के लिए विशेष छूट के साथ वफादारी कार्यक्रम लागू करने से सराहना की भावना पैदा होती है और निरंतर संरक्षण को बढ़ावा मिलता है। </label>

                    <label for="" class="mt-3"><b>बिक्री में वृद्धि:  &nbsp;</b>अच्छी तरह से डिज़ाइन किए गए कूपन के साथ लक्षित प्रचार चलाने से अल्पकालिक बिक्री में बढ़ोतरी हो सकती है। </label>
                    <label for="">सीमित समय के ऑफर तात्कालिकता की भावना पैदा करते हैं, जिससे ग्राहकों को बाद की बजाय जल्द ही खरीदारी करने के लिए प्रेरित किया जाता है। </label>

                    <label for="" class="mt-3"><b> विपणन के अवसर: &nbsp;</b> कूपन विपणन अभियानों के लिए मूल्यवान उपकरण के रूप में काम करते हैं, जिससे आप विशिष्ट प्रचारों की सफलता को ट्रैक कर सकते हैं।  </label>
                    <label for="">अपनी पहुंच का विस्तार करने और व्यापक दर्शकों को शामिल करने के लिए ईमेल, सोशल मीडिया और साझेदारी जैसे विभिन्न चैनलों पर कूपन का लाभ उठाएं। </label>

                    <label for="" class="mt-3"><b>इन्वेंटरी साफ़ करना: &nbsp;</b> इन्वेंट्री को तेज़ी से स्थानांतरित करने के लिए रणनीतिक रूप से कूपन का उपयोग करें, खासकर यदि आपके पास अधिशेष स्टॉक या मौसमी आइटम हैं।  </label>
                    <label for="">आकर्षक छूट के साथ क्लीयरेंस बिक्री धीमी गति से चलने वाले उत्पादों को राजस्व में बदल सकती है, अतिरिक्त स्टॉक और संभावित नुकसान को रोक सकती है। </label>

                    <label for="" class="mt-3"><b> ग्राहक जुड़ाव:&nbsp;</b> कूपन आपकी मार्केटिंग रणनीति को एक इंटरैक्टिव तत्व प्रदान करते हैं, जो आपके दर्शकों के साथ जुड़ाव को बढ़ावा देते हैं। </label>
                    <label for="">प्रचार बनाकर सामाजिक साझाकरण को प्रोत्साहित करें जो ग्राहकों को दोस्तों को रेफर करने या सोशल मीडिया पर अपनी खरीदारी साझा करने के लिए पुरस्कृत करता है। </label>

                    <label for="" class="mt-3"><b>डेटा संग्रह: &nbsp;</b> ग्राहकों को कूपन कोड के बदले में साइन अप करने या जानकारी प्रदान करने की आवश्यकता होती है, जिससे आपको भविष्य के विपणन प्रयासों के लिए एक मूल्यवान डेटाबेस बनाने में मदद मिलती है। </label>
                    <label for="">अपने ग्राहक जनसांख्यिकी को बेहतर ढंग से समझें और एकत्रित डेटा के आधार पर भविष्य के प्रचारों को तैयार करें। </label>

                    <label for="" class="mt-3"><b>प्रतिस्पर्धात्मक बढ़त:  &nbsp;</b>प्रतिस्पर्धी बाजार में, छूट की पेशकश एक विभेदक कारक हो सकती है जो आपके व्यवसाय को अलग करती है। </label>
                    <label for=""> सक्रिय रूप से सर्वोत्तम सौदे और प्रमोशन चाहने वाले उपभोक्ताओं के लिए शीर्ष पर रहें।  </label>
                </div>

                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id='5'>
                    <h2 class="mt-3">पे जी के कूपन का उपयोग क्यों करें: </h2>
                    <label for="" class="mt-4"><b> अनुकूलन और लचीलापन: &nbsp;</b>हमारा कूपन सिस्टम अत्यधिक अनुकूलन योग्य है, जो आपको अपने ब्रांड और मार्केटिंग रणनीति के अनुरूप प्रचार बनाने की अनुमति देता है। </label>
                    <label for="">अपने ग्राहक आधार की विविध आवश्यकताओं के अनुरूप विशिष्ट छूट मान और प्रतिशत-छूट निर्धारित करें, या एक खरीदें-एक पाएं (बीओजीओ) ऑफ़र बनाएं। </label>


                    <label for="" class="mt-4"><b>लक्षित प्रचार: &nbsp;</b>  विशिष्ट ग्राहक खंडों तक पहुंचने के लिए हमारे उन्नत लक्ष्यीकरण विकल्पों का लाभ उठाएं। </label>
                    <label for="">अपने अभियानों के प्रभाव को अधिकतम करने के लिए ग्राहक जनसांख्यिकी, खरीदारी इतिहास या अन्य मानदंडों के आधार पर प्रचार तैयार करें। </label>


                    <label for="" class="mt-4"><b>निर्बाध एकीकरण: &nbsp;</b>  हमारी कूपन कार्यक्षमता आपकी मौजूदा चेकआउट प्रक्रिया के साथ सहजता से एकीकृत होती है, जो आपको और आपके ग्राहकों दोनों के लिए एक सहज अनुभव प्रदान करती है। </label>
                    <label for="">कोई जटिल सेटअप नहीं - बस हमारे उपयोगकर्ता-अनुकूल मर्चेंट डैशबोर्ड के माध्यम से सीधे कूपन बनाएं और प्रबंधित करें। </label>


                    <label for="" class="mt-4"><b>रीयल-टाइम एनालिटिक्स:  &nbsp;</b>रीयल-टाइम एनालिटिक्स के साथ अपने प्रचारों के प्रदर्शन के बारे में जानकारी प्राप्त करें। </label>
                    <label for="">भविष्य की मार्केटिंग रणनीतियों के लिए डेटा-संचालित निर्णय लेने के लिए कूपन मोचन, ग्राहक जुड़ाव और समग्र अभियान की सफलता को ट्रैक करें। </label>


                    <label for="" class="mt-4"><b>मल्टी-चैनल वितरण:  &nbsp;</b> विभिन्न चैनलों पर कूपन वितरित करके अपनी पहुंच बढ़ाएं। </label>
                    <label for=""> अधिकतम प्रदर्शन सुनिश्चित करने के लिए ईमेल अभियानों, सोशल मीडिया या यहां तक कि साझेदार सहयोग के माध्यम से आसानी से प्रचार साझा करें। </label>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'6')" (mouseout)="showpayment(false,'6')"
                    id='6'>
                    <h2 class="mt-4">  व्यापारियों के लिए लाभ:  </h2>

                    <label for="" class="mt-4"><b>बढ़ी हुई रूपांतरण दरें: &nbsp;</b> हमारे रणनीतिक रूप से डिज़ाइन किए गए कूपन रूपांतरण दरों को बढ़ावा देने, संभावित ग्राहकों को वफादार संरक्षक में बदलने में सिद्ध हुए हैं। </label>
                    <label for="" class="mt-4"><b> ब्रांड निष्ठा और प्रतिधारण: &nbsp;</b> विशेष छूट और प्रमोशन की पेशकश करके अपने ग्राहकों के साथ दीर्घकालिक संबंधों को बढ़ावा दें जो उन्हें वापस लाते रहें। </label>
                    <label for="" class="mt-4"><b>प्रतिस्पर्धा में बढ़त: &nbsp;</b> अपने लक्षित दर्शकों का ध्यान खींचने वाले अनूठे और आकर्षक प्रचारों का लाभ उठाकर प्रतिस्पर्धा में आगे रहें। </label>
                    <label for="" class="mt-4"><b> सहज प्रबंधन: &nbsp;</b> हमारा सहज डैशबोर्ड तकनीकी विशेषज्ञता की आवश्यकता के बिना आपके कूपन अभियानों को बनाना, मॉनिटर करना और समायोजित करना आसान बनाता है। </label>
                    <label for="" class="mt-4"><b>डेटा-संचालित मार्केटिंग:  &nbsp;</b>अपनी मार्केटिंग रणनीतियों को परिष्कृत करने और भविष्य के अभियानों को अनुकूलित करने के लिए हमारे कूपन सिस्टम द्वारा उत्पन्न डेटा का उपयोग करें। </label>
               
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                   
Creating Booking and Ticketing Profile
</span>
                            </div>
                        </div>
                    </a> -->
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">

                                    कूपन क्या है?  
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">

                                    यह काम किस प्रकार करता है?  
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">

                                    यह किस प्रकार सहायता करता है?
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">

                                    पे जी के कूपन का उपयोग क्यों करें?  
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#6">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='6'}"
                                    (click)="color('6')">
                                    कूपन के लाभ   
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/features']"> <button class="btn btn-color" > <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पे जी फीचर्स 
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/price']"> <button class="btn btn-color"
                        (click)="menues('Web Integration')">मूल्य मिलान
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>
</div>